import yup from 'src/utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchApiKeys, FETCH_API_KEYS }: any = createTypedAction(
  `${PREFIX}FETCH_API_KEYS`,
  ['paginationDetails', yup.object().nullable()],
);

export const { fetchApiKeysSuccess, FETCH_API_KEYS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_API_KEYS_SUCCESS`,
  ['keys', yup.immutable().list().required()],
  ['total', yup.number().required()],
  ['totalPages', yup.number()]
);

export const { fetchApiKeysFailed, FETCH_API_KEYS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_API_KEYS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { deleteApiKey, DELETE_API_KEY }: any = createTypedAction(
  `${PREFIX}DELETE_API_KEY`,
  ['keyId', yup.string().required()],
);

export const { deleteApiKeySuccess, DELETE_API_KEY_SUCCESS }: any = createTypedAction(
  `${PREFIX}DELETE_API_KEY_SUCCESS`,
  ['keyId', yup.string().required()],
);

export const { deleteApiKeyFailed, DELETE_API_KEY_FAILED }: any = createTypedAction(
  `${PREFIX}DELETE_API_KEY_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { createApiKey, CREATE_API_KEY }: any = createTypedAction(
  `${PREFIX}CREATE_API_KEY`,
  ['roles', yup.array().of(yup.string()).default([])],
  ['name', yup.string().nullable().default(null)]
);

export const { createApiKeySuccess, CREATE_API_KEY_SUCCESS }: any = createTypedAction(
  `${PREFIX}CREATE_API_KEY_SUCCESS`,
  ['apiKey', yup.immutable().map().required()],
  ['token', yup.string().required()]
);

export const { createApiKeyFailed, CREATE_API_KEY_FAILED }: any = createTypedAction(
  `${PREFIX}CREATE_API_KEY_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { clearApiKeyToken, CLEAR_API_KEY_TOKEN }: any = createTypedAction(
  `${PREFIX}CLEAR_API_KEY_TOKEN`
);

export const { updateApiKey, UPDATE_API_KEY }: any = createTypedAction(
  `${PREFIX}UPDATE_API_KEY`,
  ['keyId', yup.string().required()],
  ['name', yup.string().nullable().default(null)],
  ['roles', yup.array().of(yup.string()).default([])]
);

export const { updateApiKeySuccess, UPDATE_API_KEY_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_API_KEY_SUCCESS`,
  ['apiKey', yup.immutable().map().required()]
);

export const { updateApiKeyFailed, UPDATE_API_KEY_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_API_KEY_FAILED`,
  ['err', yup.immutable().map().nullable()]
);
